<template>
	<div id="login-page" data-aos="fade">
		<div class="login-wrapper">
			<div class="login-form-box">
				<div class="login-brand">
					<p class="login-eyebrow">Acceso</p>
					<h1 class="login-title">Bienvenido de nuevo</h1>
					<p class="login-lead">Ingresa tus credenciales para continuar.</p>
				</div>

				<b-form @submit.prevent="handleLogin">
					<b-form-group
						label="Correo electrónico"
						label-for="email"
						label-class="login-label"
					>
						<div class="input-with-icon">
							<i class="fa-regular fa-envelope input-icon"></i>
							<b-form-input
								id="email"
								v-model="email"
								type="email"
								placeholder="ejemplo@correo.com"
								required
								class="login-input"
							></b-form-input>
						</div>
					</b-form-group>

					<b-form-group
						label="Contraseña"
						label-for="password"
						label-class="login-label"
					>
						<div class="input-with-icon">
							<i class="fa-regular fa-lock input-icon"></i>
							<b-form-input
								id="password"
								v-model="password"
								type="password"
								placeholder="••••••••"
								required
								class="login-input"
							></b-form-input>
						</div>
					</b-form-group>

					<div class="forgot-row">
						<a href="#" class="forgot-link">¿Olvidaste tu contraseña?</a>
					</div>

					<b-button
						type="submit"
						block
						size="lg"
						class="btn-login"
						:disabled="isLoading"
					>
						<template v-if="isLoading">Iniciando sesión...</template>
						<template v-else>
							Iniciar sesión
							<i class="fa-regular fa-arrow-right ml-2"></i>
						</template>
					</b-button>

					<div class="login-divider">
						<span>o</span>
					</div>

					<b-button
						to="/afiliacion"
						variant="outline-secondary"
						block
						size="lg"
						class="btn-register"
					>
						Crear cuenta nueva
					</b-button>
				</b-form>

				<p class="login-legal">
					Al iniciar sesión aceptas nuestros
					<router-link to="/terminos-y-condiciones">Términos de uso</router-link>
					y el
					<router-link to="/aviso-de-privacidad">Aviso de Privacidad</router-link>.
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LoginPage',

	data() {
		return {
			email: '',
			password: '',
			isLoading: false,
		}
	},

	methods: {
		handleLogin() {
			this.isLoading = true

			setTimeout(() => {
				localStorage.setItem('userLoggedIn', 'true')
				localStorage.setItem('userName', this.email.split('@')[0])
				localStorage.setItem('userEmail', this.email)
				this.isLoading = false
				this.$router.push('/mi-cuenta')
			}, 1000)
		},
	},
}
</script>
